import styled, { css } from 'styled-components';

export const PageDivLayout = styled.section`
  width: 100%;
`;

export const TagDiv = styled.section`
  weight: 100%;
  ${({ sideBar }) =>
    sideBar &&
    css`
      filter: blur(4px);
    `}
  .page {
    width: calc(100% - 9rem);
    margin-left: 9rem;
    height: 100%;
    @media (max-width: 900px) {
      height: 100%;
      width: 100%;
      margin-left: 0;
    }
  }

  .top-tags {
    bottom: auto;
    top: 3.125rem;
    @media (max-width: 695px) {
      top: 2.5rem;
    }
  }

  .tags {
    color: #3bcfe3;
    opacity: 0.3;
    position: absolute;
    bottom: 0;
    left: 60px;
    font-size: 18px;
    font-family: 'La Belle Aurore', cursive;

    @media (max-width: 1280px) {
      left: 50px;
    }
    @media (max-width: 968px) {
      left: 40px;
    }
    @media (max-width: 650px) {
      left: 30px;
    }
    @media (max-width: 598px) {
      left: 20px;
    }

    @media (max-width: 355px) {
      left: 20px;
    }
  }

  .bottom-tags {
    top: auto;
    bottom: 50px;

    @media (max-width: 900px) {
      bottom: 110px;
    }
    @media (max-width: 695px) {
      bottom: -95px;
    }
    @media (max-width: 520px) {
      bottom: -105px;
    }
    @media (max-width: 450px) {
      bottom: -97px;
    }
    @media (max-width: 380px) {
      bottom: -117px;
    }
    @media (max-width: 340px) {
      bottom: -285px;
    }
  }

  .bottom-tag-html {
    position: absolute;
    left: 60px;
    margin-left: -20px;
    bottom: 22px;
    @media (max-width: 900px) {
      bottom: 75px;
    }
    @media (max-width: 1280px) {
      left: 50px;
    }
    @media (max-width: 695px) {
      bottom: -127px;
    }
    @media (max-width: 650px) {
      left: 25px;
    }
    @media (max-width: 520px) {
      bottom: -137px;
    }

    @media (max-width: 355px) {
      left: 25px;
    }
    @media (max-width: 450px) {
      bottom: -117px;
    }
    @media (max-width: 380px) {
      bottom: -173px;
      padding-bottom: 2rem;
    }
    @media (max-width: 340px) {
      bottom: -305px;
    }
  }
`;
